/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Broken_Links_RelinkInputs */



/**
* | output |
* | --- |
* | "Re-link with my access" |
*
* @param {Project_Broken_Links_RelinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_broken_links_relink = /** @type {((inputs?: Project_Broken_Links_RelinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Broken_Links_RelinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit meinem Zugriff neu verknüpfen")
	return /** @type {LocalizedString} */ ("Re-link with my access")
});